import { render, staticRenderFns } from "./titleDetails.vue?vue&type=template&id=17475e7c&scoped=true&lang=pug&"
import script from "./titleDetails.vue?vue&type=script&lang=js&"
export * from "./titleDetails.vue?vue&type=script&lang=js&"
import style0 from "./titleDetails.vue?vue&type=style&index=0&id=17475e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17475e7c",
  null
  
)

export default component.exports